const EMPTY_REFERENCE = '暂无参考范围'

function formatDateTime (value) {
  const text = String(value).trim()
  if (/^\d{14}$/.test(text)) {
    return `${text.slice(0, 4)}-${text.slice(4, 6)}-${text.slice(6, 8)} ${text.slice(8, 10)}:${text.slice(10, 12)}:${text.slice(12, 14)}`
  }
  const match = text.match(/^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})(?::(\d{2}))?/)
  return match ? `${match[1]} ${match[2]}:${match[3] || '00'}` : text
}

const sections = [
  {
    title: '睡眠时间',
    metrics: [
      { name: '上床时间', aliases: ['bedtime', 'bedTime', 'inBedTime', 'goToBedTime', '上床时间'], reference: '最佳为22点，大多数位于20-23点', format: 'dateTime', normalRange: { type: 'timeOfDay', min: 20 * 60, max: 23 * 60 } },
      { name: '离床时间', aliases: ['wake_time', 'wakeTime', 'wakeUpTime', 'sleepEndTime', '离床时间'], reference: '5点半到8点；早起型5:00-6:00，晚睡型约7:00-8:00', format: 'dateTime', normalRange: { type: 'timeOfDay', min: 5 * 60 + 30, max: 8 * 60 } },
      { name: '在床时长', aliases: ['total_bed_time', 'bedDuration', 'timeInBed', 'inBedDuration', '在床时长'], format: 'duration', normalRange: { min: 7, max: 9 } },
      { name: '入睡时间', aliases: ['sleep_time', 'fallAsleepTime', 'sleepStartTime', 'sleepAt', '入睡时间'], format: 'dateTime', normalRange: { type: 'timeOfDay', min: 20 * 60, max: 23 * 60 } },
      { name: '醒来时间', aliases: ['wake_up_time', 'leaveBedTime', 'outBedTime', 'getUpTime', '醒来时间'], format: 'dateTime', normalRange: { type: 'timeOfDay', min: 5 * 60, max: 8 * 60 } },
      { name: '入睡时长', aliases: ['sleep_latency', 'sleepLatency', 'fallAsleepDuration', '入睡时长'], reference: '入睡潜伏期5-20分钟，少于30分钟为正常', format: 'minutes', normalRange: { min: 5, max: 30 } },
      { name: '睡眠时长', aliases: ['total_sleep_time', 'totalSleepTime', 'sleepDuration', 'totalSleepDuration', '睡眠时长'], reference: '健康人中总睡眠时间7–9h；18–30岁健康人约8.3h‍；≥60岁健康人约7.7h‍；健康成人日常约7.3h；中老年失眠患者51.94%在6–8h。随年龄增长，总睡眠时间会有下降。', format: 'duration', normalRange: { min: 7, max: 9 } }
    ]
  },
  {
    title: '睡眠质量',
    metrics: [
      { name: '清醒期时长', summaryKey: 'awakeTime', aliases: ['awake_time', 'awakeTime', '清醒期时长'], reference: '闭眼放松但尚未入睡的状态', format: 'hours' },
      { name: '浅睡眠时长', summaryKey: 'lightSleepTime', aliases: ['light_sleep_time', 'lightSleepTime', '浅睡眠时长'], reference: 'N1：入睡的过渡阶段，意识开始模糊且容易被唤醒，约占总睡眠时长5%-10%', format: 'hours', normalRange: { type: 'ratioOfTotalSleep', min: 0.05, max: 0.1 } },
      { name: '中睡眠时长', summaryKey: 'moderateSleepTime', aliases: ['moderate_sleep_time', 'moderateSleepTime', '中睡眠时长'], reference: 'N2：进入正式睡眠，心率和体温开始下降，约占总睡眠时长50%-60%', format: 'hours', normalRange: { type: 'ratioOfTotalSleep', min: 0.5, max: 0.6 } },
      { name: '深睡眠时长', summaryKey: 'deepSleepTime', aliases: ['deep_sleep_time', 'deepSleepTime', '深睡眠时长'], reference: 'N3：身体修复和恢复的关键阶段，约占总睡眠时长10%-20%', format: 'hours', normalRange: { type: 'ratioOfTotalSleep', min: 0.1, max: 0.2 } },
      { name: '睡眠效率', summaryKey: 'sleepEfficiency', aliases: ['sleep_efficiency', 'sleepEfficiency', '睡眠效率'], reference: '大于或等于85%为正常；65岁以上可适当放宽至大于80%', format: 'percent', normalRange: { min: 85 } },
      { name: '睡眠质量', summaryKey: 'sleepQuality', aliases: ['sleep_quality', 'sleepQuality', '睡眠质量'], reference: 'PSQI评估中主观睡眠质量、催眠药物使用和日间功能障碍需主观填写，不适用自动监测和生成评分，考虑修改，用自动采集的客观多维度数据来构建分数。' }
    ]
  },
  {
    title: '生理指标',
    metrics: [
      { name: '呼吸暂停总时间', aliases: ['apnea_total_time', 'total_apnea_time', 'apneaTotalTime', 'totalApneaTime', '呼吸暂停总时间'], reference: '正常健康人整夜呼吸暂停总时长微小，多为0或接近0分钟（以AHI小于5为标准）', format: 'seconds', normalRange: { max: 0 } },
      { name: '呼吸暂停次数', aliases: ['apnea', 'apnea_count', 'apneaCount', 'apneaTimes', '呼吸暂停次数'], reference: '整夜呼吸暂停次数极少。AHI<5/h，但健康人中实际次数远低于此，多数为0或个别偶发', format: 'count', normalRange: { max: 0 } },
      { name: '呼吸暂停最长时间', aliases: ['max_apnea', 'max_apnea_time', 'maxApneaTime', 'longestApneaTime', '呼吸暂停最长时间'], reference: '≤25秒左右。正常组平均事件时长约12–25秒', format: 'seconds', normalRange: { max: 25 } },
      { name: '呼吸总次数', aliases: ['total_breaths', 'total_breath_count', 'totalBreathCount', 'breathCount', 'respirationCount', '呼吸总次数'], reference: '按呼吸频率12-20次/分作为参考', format: 'count' },
      { name: '平均呼吸次数/分', aliases: ['adv_breathing', 'avgRespiratoryRate', 'averageRespiratoryRate', 'avgBreathRate', 'averageBreathRate', '平均呼吸次数/分'], reference: '12-20次/分钟（睡眠期略低于清醒静息值）', format: 'rpm', normalRange: { min: 12, max: 20 } },
      { name: '最高呼吸次数/分', aliases: ['max_breathing', 'maxRespiratoryRate', 'maxBreathRate', '最高呼吸次数/分'], reference: '正常睡眠期间呼吸频率波动，最高一般不超过20–25次/分（受REM期或微觉醒影响可一过性增高）', format: 'rpm', normalRange: { max: 25 } },
      { name: '最低呼吸次数/分', aliases: ['min_breathing', 'minRespiratoryRate', 'minBreathRate', '最低呼吸次数/分'], reference: 'NREM深睡眠期呼吸可降至10–12次/分，一般不<8次/分', format: 'rpm', normalRange: { min: 8 } },
      { name: '心跳骤停次数', aliases: ['cardiac', 'cardiac_arrest_count', 'cardiacArrestCount', 'heartStopCount', '心跳骤停次数'], reference: '0次（正常健康睡眠不应出现心跳骤停/窦性停搏）', format: 'count', normalRange: { max: 0 } },
      { name: '心跳骤停时间', aliases: ['max_cardiac', 'cardiac_arrest_time', 'cardiacArrestTime', 'heartStopTime', '心跳骤停时间'], reference: '0秒。窦性停搏>2秒即为异常，可见于OSAHS患者', format: 'seconds', normalRange: { max: 0 } },
      { name: '心率失常次数', aliases: ['arrhythmia', 'arrhythmia_count', 'arrhythmiaCount', 'irregularHeartRateCount', '心率失常次数'], reference: '正常健康人睡眠期心律失常罕见或偶发（非持续性、无症状房性/室性早搏可偶见，但频率很低）', format: 'count', normalRange: { max: 0 } },
      { name: '心率失常时间', aliases: ['max_arrhythmia', 'arrhythmia_time', 'arrhythmiaTime', 'irregularHeartRateTime', '心率失常时间'], reference: '健康人睡眠期不应有持续性心律失常', format: 'seconds', normalRange: { max: 0 } },
      { name: '心动过缓次数', aliases: ['bradycardia', 'bradycardia_count', 'bradycardiaCount', 'slowHeartRateCount', '心动过缓次数'], reference: '正常健康人睡眠期可有生理性心动过缓（心率40–50次/分），但无病理性心动过缓事件', format: 'count', normalRange: { max: 0 } },
      { name: '平均心率', aliases: ['adv_heart', 'averageHeartRate', 'avgHeartRate', 'avgHr', '平均心率'], reference: '50–80次/分（睡眠期）。静息清醒心率正常60–100次/分，睡眠期特别是NREM深睡眠期心率可降至50–60次/分', format: 'bpm', normalRange: { min: 50, max: 80 } },
      { name: '最高心率', aliases: ['max_heart', 'maxHeartRate', 'maxHr', '最高心率'], reference: '睡眠期最高一般不超过100–120次/分（可能出现在REM期或微觉醒时）', format: 'bpm', normalRange: { max: 120 } },
      { name: '最低心率', aliases: ['min_heart', 'minHeartRate', 'minHr', '最低心率'], reference: '不低于40–50次/分。心动过缓定义为<50次/分；正常睡眠中可出现窦性心动过缓（睡眠生理性），一般>40次/分', format: 'bpm', normalRange: { min: 40 } },
      { name: '体动次数', aliases: ['turning', 'turn_over_count', 'turnOverCount', 'turnoverCount', 'bodyTurnCount', 'movement', 'movementCount', '体动次数'], reference: '健康成人睡眠期体动频繁，临床上用体动次数。', format: 'count' },
      { name: '翻身次数', aliases: ['turning', 'turn_over_count', 'turnOverCount', 'turnoverCount', 'bodyTurnCount', 'movement', 'movementCount', '翻身次数'], reference: '约2–4次/小时。正常男性（AHI<5）平均翻身频率约2.77次/小时', format: 'count' },
      { name: '打鼾次数', aliases: ['snoring', 'snoring_count', 'snoringCount', '打鼾次数'], reference: '正常健康人应无或偶发打鼾。', format: 'count' },
      { name: '磨牙次数', aliases: ['bruxism', 'bruxism_count', 'bruxismCount', '磨牙次数'], reference: '一种睡眠障碍，会直接导致睡眠变浅、多梦；导致身体不适会干扰睡眠的连续性和质量；与睡眠呼吸暂停等呼吸障碍有关，导致睡眠片段化，进一步降低睡眠质量；在主观上感觉睡得很不好。', format: 'count' },
      { name: '咳嗽次数', aliases: ['cough', 'cough_count', 'coughCount', '咳嗽次数'], reference: '正常睡眠期间咳嗽应极少或0次。', format: 'count' },
      { name: '梦话次数', aliases: ['speech', 'speech_count', 'speechCount', 'sleepTalkingCount', '梦话次数'], reference: '是一种常见的睡眠异动症，导致睡眠片段化；主观睡眠质量差；偶尔一般不影响，长期、频繁的梦话可能与压力过大、过度疲劳相关，也可能与神经衰弱、焦虑症等疾病之一。', format: 'count' },
      { name: '起夜次数', aliases: ['night_rising', 'nocturiaCount', 'nightUrinationCount', '起夜次数'], reference: '正常健康成年人0–1次/晚。≥2次/晚一般视为异常', format: 'count', normalRange: { min: 0, max: 1 } }
    ]
  },
  {
    title: '疾病风险',
    metrics: [
      { name: '呼吸暂停综合征风险', aliases: ['sleep_apnea_risk', 'osaRisk', 'sleepApneaRisk', 'apneaSyndromeRisk', '呼吸暂停综合征风险'], reference: '正常健康人整夜暂停时间占比约0.8%+/-0.7%；轻度OSA约3.1%+/-2.8%，中度约7.9%+/-5.3%，重度约31.3%+/-17.6%' }
    ]
  },
  {
    title: '环境指标',
    metrics: [
      { name: '环境温度', aliases: ['temp', 'temperature', 'environmentTemperature', 'roomTemperature', '环境温度'], reference: '17-28摄氏度（参考室内环境数据）', format: 'celsius', normalRange: { min: 17, max: 28 } },
      { name: '环境湿度', aliases: ['humi', 'humidity', 'environmentHumidity', 'roomHumidity', '环境湿度'], reference: '40%-60%（参考室内环境数据）', format: 'percent', normalRange: { min: 40, max: 60 } },
      { name: 'PM2.5', aliases: ['pm25', 'pm2.5', 'PM2.5'], reference: 'WHO：年平均 ≤ 10 μg/m³，24小时平均 ≤ 25 μg/m³；中国国家标准（GB 3095-2012）：年平均 ≤ 35 μg/m³，24小时平均 ≤ 75 μg/m³', format: 'micrograms' },
      { name: '空气质量', aliases: ['aqi', 'airQuality', '空气质量'], reference: '0–50（优）：适合睡眠；51–100（良）：可接受；101–200（轻度污染）：敏感人群症状加剧，可能影响睡眠呼吸；201–300（中度污染）及以上：不宜睡眠，可致健康人群普遍出现症状。睡眠期间卧室空气质量应维持在优至良（AQI ≤ 100）' },
      { name: '环境噪音（分贝）', aliases: ['db', 'noise', 'noiseDb', 'environmentNoise', '环境噪音', '环境噪音（分贝）'], reference: 'WHO建议：不超过30 dB(A)，单次噪音事件不超过45 dB(A)；欧洲环境噪音指南：夜间（22:00–6:00）不超过40 dB(A)；中国环保标准：卧室夜间噪音不得超过30 dB(A)', format: 'decibels', normalRange: { max: 30 } }
    ]
  },
  {
    title: '助眠指标',
    metrics: [
      { name: '睡眠香薰', aliases: ['rfid', 'fragrance', 'aroma', 'sleepAroma', '睡眠香薰'], timeAliases: ['fragrant_time', 'fragrantTime', 'aroma_time', 'aromaTime'] },
      { name: '环境音乐', aliases: ['filename', 'music', 'musicName', 'environmentMusic', '环境音乐'], timeAliases: ['speaker_time', 'speakerTime', 'music_time', 'musicTime'] },
      { name: '舒曼波', aliases: ['freq', 'frequency', 'schumannWave', '舒曼波'], timeAliases: ['wave_time', 'waveTime'], unit: 'Hz' },
      { name: '灯光类型', aliases: ['light', 'lightType', '灯光类型'], timeAliases: ['light_time', 'lightTime'] },
      { name: '呼吸疗愈', aliases: ['breathingHealing', 'breathHealing', 'breathing_healing', 'breath_healing', '呼吸疗愈'], timeAliases: ['breathing_healing_time', 'breath_healing_time', 'breathingHealingTime', 'breathHealingTime'] }
    ]
  },
  {
    title: '睡眠变化',
    metrics: [
      { name: '环境音乐', aliases: ['filename', 'music', 'musicName', 'environmentMusic', '环境音乐'], timeAliases: ['speaker_time', 'speakerTime', 'music_time', 'musicTime'] },
      { name: '睡眠香薰', aliases: ['rfid', 'fragrance', 'aroma', 'sleepAroma', '睡眠香薰'], timeAliases: ['fragrant_time', 'fragrantTime', 'aroma_time', 'aromaTime'] },
      { name: '灯光类型', aliases: ['light', 'lightType', '灯光类型'], timeAliases: ['light_time', 'lightTime'] },
      { name: '舒曼波', aliases: ['freq', 'frequency', 'schumannWave', '舒曼波'], timeAliases: ['wave_time', 'waveTime'], unit: 'Hz' },
      { name: '入睡时长变化', aliases: ['sleep_latency_change', 'sleepLatencyChange'], changeLabels: ['入睡时长', '入睡时间'] },
      { name: '浅睡眠时长变化', aliases: ['light_sleep_time_change', 'lightSleepTimeChange'], changeLabels: ['浅睡眠时长'] },
      { name: '中睡眠时长变化', aliases: ['moderate_sleep_time_change', 'moderateSleepTimeChange'], changeLabels: ['中睡眠时长'] },
      { name: '清醒期时长变化', aliases: ['awake_time_change', 'awakeTimeChange'], changeLabels: ['清醒期时长', '清醒期'] },
      { name: '打鼾次数变化', aliases: ['snoring_change', 'snoringChange'], changeLabels: ['打鼾次数'] },
      { name: '磨牙次数变化', aliases: ['bruxism_change', 'bruxismChange'], changeLabels: ['磨牙次数'] },
      { name: '梦话次数变化', aliases: ['speech_change', 'speechChange'], changeLabels: ['梦话次数'] },
      { name: '咳嗽次数变化', aliases: ['cough_change', 'coughChange'], changeLabels: ['咳嗽次数'] },
      { name: '起夜次数变化', aliases: ['night_rising_change', 'nightRisingChange'], changeLabels: ['起夜次数'] },
      { name: '呼吸暂停次数变化', aliases: ['apnea_change', 'apneaChange'], changeLabels: ['呼吸暂停次数'] },
      { name: '睡眠效率变化百分比', aliases: ['sleep_efficiency_change', 'sleepEfficiencyChange'], changeLabels: ['睡眠效率', '睡眠质量'], format: 'percent' },
      { name: '睡眠效率超过的人群百分比', aliases: ['sleep_efficiency_percentile', 'sleepEfficiencyPercentile', 'sleepEfficiencyCrowdPercent'], populationPercent: true, format: 'percent' }
    ]
  }
]

function normalizeKey (value) {
  return String(value).toLowerCase().replace(/[\s_\-/.()%]+/g, '')
}

function isObject (value) {
  return value && typeof value === 'object' && !Array.isArray(value)
}

function parseJson (value) {
  if (!value || !String(value).trim()) return null
  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

function flatten (value, result = new Map()) {
  if (Array.isArray(value)) {
    value.forEach(item => flatten(item, result))
    return result
  }
  if (!isObject(value)) return result
  Object.keys(value).forEach(key => {
    const item = value[key]
    if (isObject(item) || Array.isArray(item)) flatten(item, result)
    else if (!result.has(normalizeKey(key))) result.set(normalizeKey(key), item)
  })
  return result
}

function findValue (values, aliases) {
  for (const alias of aliases || []) {
    const value = values.get(normalizeKey(alias))
    if (value !== undefined && value !== null && String(value).trim() !== '') return value
  }
  return undefined
}

function escapeRegExp (value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

function findTextValue (text, label) {
  const match = text.match(new RegExp(`${escapeRegExp(label)}\\s*(?:为|[:：])\\s*([^，。；;\\n]+)`))
  return match && match[1] ? match[1].trim() : undefined
}

function findChangeTextValue (text, labels) {
  for (const label of labels || []) {
    const match = text.match(new RegExp(
      `${escapeRegExp(label)}(?:\\s*和(?:昨天|上次|前次)相比)?\\s*(增加|减少|上升|下降|提高|降低|延长|缩短|变长|变短)了?\\s*([^，,。；;\\n]+)`
    ))
    if (match && match[1] && match[2]) return `${match[1]}了${match[2].trim()}`
  }
  return undefined
}

function findPopulationPercent (text) {
  const match = text.match(/超过了?\s*([\d.]+%)\s*的人群/)
  return match && match[1] ? match[1] : undefined
}

function formatTimedValue (values, metric) {
  const value = findValue(values, metric.aliases)
  const time = findValue(values, metric.timeAliases)
  if (value === undefined && time === undefined) return undefined
  const text = value === undefined ? '' : String(value).trim()
  const valueText = text && metric.unit && !text.toLowerCase().endsWith(metric.unit.toLowerCase())
    ? `${text}${metric.unit}`
    : text
  if (valueText && time !== undefined) return `${valueText}（${String(time).trim()}）`
  return valueText || String(time).trim()
}

function parseMetricDateTime (value) {
  const text = String(value || '').trim()
  if (/^\d{14}$/.test(text)) {
    const date = Date.UTC(
      Number(text.slice(0, 4)),
      Number(text.slice(4, 6)) - 1,
      Number(text.slice(6, 8)),
      Number(text.slice(8, 10)),
      Number(text.slice(10, 12)),
      Number(text.slice(12, 14))
    )
    return Number.isFinite(date) ? date : undefined
  }
  const date = Date.parse(text)
  return Number.isFinite(date) ? date : undefined
}

function deriveSleepLatency (values) {
  const bedtime = parseMetricDateTime(findValue(values, ['bedtime', 'bedTime']))
  const sleepTime = parseMetricDateTime(findValue(values, ['sleep_time', 'sleepTime']))
  if (bedtime === undefined || sleepTime === undefined || sleepTime < bedtime) return undefined
  return Math.round((sleepTime - bedtime) / 60000)
}

function formatHours (value) {
  const number = Number.parseFloat(String(value))
  if (!Number.isFinite(number)) return String(value)
  const totalSeconds = Math.round(number * 3600)
  if (totalSeconds === 0) return '0小时'
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  const parts = []
  if (hours) parts.push(`${hours}小时`)
  if (minutes) parts.push(`${minutes}分钟`)
  if (seconds || !parts.length) parts.push(`${seconds}秒`)
  return parts.join('')
}

function hasUnit (value) {
  return /[\u4e00-\u9fa5%]|bpm|rpm|h|min|s|℃|°C/i.test(value)
}

function formatValue (value, format) {
  if (value === undefined || value === null || String(value).trim() === '') return '--'
  const text = String(value).trim()
  if (hasUnit(text) || !format) return text
  if (format === 'dateTime') return formatDateTime(text)
  if (format === 'hours' || format === 'duration') return formatHours(text)
  if (format === 'minutes') return `${text}分钟`
  if (format === 'percent') return `${text}%`
  if (format === 'count') return `${text}次`
  if (format === 'seconds') return `${text}秒`
  if (format === 'bpm' || format === 'rpm') return `${text}次/分`
  if (format === 'celsius') return `${text}摄氏度`
  if (format === 'micrograms') return `${text}μg/m³`
  if (format === 'decibels') return `${text}分贝`
  return text
}

function rawSources (detail) {
  return [detail.report, detail.reportDetail, detail.sleepState, detail.sleepStage, detail.sleepEnvironment]
    .map(parseJson)
    .filter(value => value !== null)
}

function parseNumber (value) {
  if (value === undefined || value === null || String(value).trim() === '') return undefined
  const number = typeof value === 'number' ? value : Number.parseFloat(String(value))
  return Number.isFinite(number) ? number : undefined
}

function parseTimeOfDay (value) {
  if (value === undefined || value === null || String(value).trim() === '') return undefined
  const text = String(value).trim()
  const compact = text.match(/^\d{8}(\d{2})(\d{2})(\d{2})?$/)
  if (compact) return Number(compact[1]) * 60 + Number(compact[2])
  const match = text.match(/(?:T|\s|^)(\d{1,2}):(\d{2})(?::\d{2})?/)
  if (!match) return undefined
  const hours = Number(match[1])
  const minutes = Number(match[2])
  if (!Number.isFinite(hours) || !Number.isFinite(minutes) || hours > 23 || minutes > 59) return undefined
  return hours * 60 + minutes
}

function isWithinTimeRange (value, min, max) {
  return min <= max ? value >= min && value <= max : value >= min || value <= max
}

function resolveMetricStatus (value, range, values) {
  if (!range) return undefined
  if (range.type === 'timeOfDay') {
    const minutes = parseTimeOfDay(value)
    if (minutes === undefined) return undefined
    if (isWithinTimeRange(minutes, range.min, range.max)) return 'normal'
    return minutes < range.min ? 'low' : 'high'
  }
  if (range.type === 'ratioOfTotalSleep') {
    const numerator = parseNumber(value)
    const denominator = parseNumber(findValue(values, ['total_sleep_time', 'totalSleepTime', 'sleepDuration', 'totalSleepDuration', '睡眠时长']))
    if (numerator === undefined || denominator === undefined || denominator <= 0) return undefined
    const ratio = numerator / denominator
    if (ratio < range.min) return 'low'
    if (ratio > range.max) return 'high'
    return 'normal'
  }
  const number = parseNumber(value)
  if (number === undefined) return undefined
  if (range.min !== undefined && number < range.min) return 'low'
  if (range.max !== undefined && number > range.max) return 'high'
  return 'normal'
}

export function buildReportSections (detail) {
  const values = new Map()
  rawSources(detail).forEach(source => flatten(source, values))
  const text = [detail.report, detail.reportDetail].filter(value => typeof value === 'string').join('\n')
  return sections.map(section => ({
    title: section.title,
    rows: section.metrics.map(metric => {
      const summaryValue = metric.summaryKey ? detail[metric.summaryKey] : undefined
      const derivedValue = metric.name === '入睡时长' ? deriveSleepLatency(values) : undefined
      const timedValue = metric.timeAliases ? formatTimedValue(values, metric) : undefined
      const changeValue = metric.changeLabels
        ? findValue(values, metric.aliases) ?? findChangeTextValue(text, metric.changeLabels)
        : undefined
      const populationPercent = metric.populationPercent
        ? findValue(values, metric.aliases) ?? findPopulationPercent(text)
        : undefined
      const sourceValue = timedValue ?? changeValue ?? populationPercent ?? findValue(values, metric.aliases) ?? derivedValue ?? findTextValue(text, metric.name)
      const hasSummary = summaryValue !== undefined && summaryValue !== null && String(summaryValue).trim() !== ''
      const value = hasSummary
        ? metric.summaryKey === 'sleepEfficiency' ? formatValue(summaryValue, 'percent') : formatValue(summaryValue, metric.format)
        : formatValue(sourceValue, metric.format)
      return {
        name: metric.name,
        value,
        reference: metric.reference || EMPTY_REFERENCE,
        status: metric.reference
          ? resolveMetricStatus(hasSummary ? summaryValue : sourceValue, metric.normalRange, values)
          : undefined
      }
    })
  }))
}

const heartAliases = ['heartRate', 'heart_rate', 'heart', 'hr']
const breathAliases = ['breathing', 'respirationRate', 'respiratoryRate', 'breathRate', 'respiration']
const timeAliases = ['reportTime', 'timestamp', 'time', 'dateTime', 'datetime']

function propertyValue (record, aliases) {
  const values = new Map(Object.keys(record).map(key => [normalizeKey(key), record[key]]))
  return findValue(values, aliases)
}

function numericValue (value) {
  const number = typeof value === 'number' ? value : Number.parseFloat(String(value))
  return Number.isFinite(number) ? number : null
}

function labelValue (value, index) {
  if (value === undefined || value === null || String(value).trim() === '') return String(index + 1)
  const text = String(value)
  if (/^\d{14}$/.test(text)) return `${text.slice(8, 10)}:${text.slice(10, 12)}`
  return text
}

function findSeries (value) {
  if (Array.isArray(value) && value.length && value.every(isObject)) {
    const points = value.map((item, index) => ({
      label: labelValue(propertyValue(item, timeAliases), index),
      heartRate: numericValue(propertyValue(item, heartAliases)),
      respirationRate: numericValue(propertyValue(item, breathAliases))
    })).filter(point => point.heartRate !== null || point.respirationRate !== null)
    if (points.length) {
      return {
        labels: points.map(point => point.label),
        heartRate: points.map(point => point.heartRate),
        respirationRate: points.map(point => point.respirationRate)
      }
    }
  }
  if (Array.isArray(value)) {
    for (const item of value) {
      const found = findSeries(item)
      if (found) return found
    }
  } else if (isObject(value)) {
    const heart = propertyValue(value, heartAliases)
    const breath = propertyValue(value, breathAliases)
    const times = propertyValue(value, timeAliases)
    if (Array.isArray(heart) && Array.isArray(breath)) {
      const points = Array.from({ length: Math.min(heart.length, breath.length) }, (_, index) => ({
        label: labelValue(Array.isArray(times) ? times[index] : undefined, index),
        heartRate: numericValue(heart[index]),
        respirationRate: numericValue(breath[index])
      })).filter(point => point.heartRate !== null || point.respirationRate !== null)
      if (points.length) {
        return {
          labels: points.map(point => point.label),
          heartRate: points.map(point => point.heartRate),
          respirationRate: points.map(point => point.respirationRate)
        }
      }
    }
    for (const item of Object.values(value)) {
      const found = findSeries(item)
      if (found) return found
    }
  }
  return null
}

export function extractVitalSeries (detail) {
  return findSeries(detail.vitalSigns) || rawSources(detail).map(findSeries).find(Boolean) || null
}

const sleepStageNames = {
  1: '深睡眠期',
  2: '中睡眠期',
  3: '浅睡眠期',
  4: '清醒'
}

export function extractSleepStageSeries (detail) {
  if (!detail || !Array.isArray(detail.sleepStages)) return null
  const points = detail.sleepStages.reduce((result, item) => {
    if (!isObject(item)) return result
    const time = typeof item.time === 'string' ? item.time.trim() : ''
    const timestamp = Date.parse(time)
    const stage = sleepStageNames[Number(item.sleepValue)]
    const match = time.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/)
    if (!Number.isFinite(timestamp) || !stage || !match) return result
    result.push({
      timestamp,
      label: `${match[2]}:${match[3]}`,
      time: `${match[1]} ${match[2]}:${match[3]}:${match[4] || '00'}`,
      stage
    })
    return result
  }, []).sort((left, right) => left.timestamp - right.timestamp)

  return points.length
    ? {
      labels: points.map(point => point.label),
      times: points.map(point => point.time),
      stages: points.map(point => point.stage)
    }
    : null
}
